document.addEventListener('DOMContentLoaded', function () {
    let progressBar = document.getElementById('telehealthProgressBar');
    let intervalDuration = 7000; // duration in milliseconds
    let wrappers = document.querySelectorAll('.telehealth-reviews .review-card-wrapper');
    let customerImage = document.querySelector('.telehealth-reviews .customer-image-section img');
    let currentIndex = 0;
    let startTime = performance.now();
    let progressInterval;

    function showReview(index) {
        wrappers.forEach(function (wrapper) {
            wrapper.classList.remove('active');
        });
        if (wrappers[index]) {
            wrappers[index].classList.add('active');
        }
        updateCustomerImage(index);
    }

    function updateCustomerImage(index) {
        // Get the active review wrapper
        let activeReview = wrappers[index];

        // Get the reviewer image from the active review
        let reviewerImage = activeReview.querySelector('.telehealth-reviews .reviewedBy img');

        // Update the customer image source with the reviewer image source
        if (reviewerImage) {
            customerImage.src = reviewerImage.src;
        }
    }

    function updateProgressBar() {
        let elapsedTime = performance.now() - startTime;
        let progressValue = (elapsedTime / intervalDuration) * 100;
        progressBar.value = Math.min(progressValue, 100);
        if (progressValue < 100) {
            requestAnimationFrame(updateProgressBar);
        } else {
            startTime = performance.now(); // Reset start time for the next cycle
            setTimeout(updateProgressBar, 10);
        }
    }

    function nextReview() {
        currentIndex = (currentIndex + 1) % wrappers.length;
        showReview(currentIndex);
        startTime = performance.now(); // Reset start time for the next cycle
        requestAnimationFrame(updateProgressBar);
    }

    showReview(currentIndex);
    updateProgressBar();
    setInterval(nextReview, intervalDuration);
});